import { TimePicker } from 'antd';
import styled from 'styled-components';

export default styled(TimePicker)`
	// Add your styles here
`;
